<template>

    <bottom-sheet ref="bottomsheet">

        <div class="bsfn__container">

            <h1 class="bsfn__title">{{ $t('settings_sure_disconnect') }}</h1>

            <button class="btn btn-red bsfn__btn-red" @click="disconnect">{{  $t('settings_disconnect')}}</button>

            <button class="btn btn-grey bsfn__btn-grey" @click="close">{{ $t('settings_cta_cancel_delete') }}</button>

        </div>

    </bottom-sheet>

</template>

<script>

import Auth from '@/modules/auth'

import BottomSheet from '@/components/bottomSheet/BottomSheet'

export default {

    name: 'bottom-sheet-fetch-notifications',

    components: {BottomSheet},

    data() {
        return {
            show: false
        }
    },

    methods: {

        open() {
            this.$refs.bottomsheet.open()
        },

        close() {
            this.$refs.bottomsheet.close()
            this.$emit('close')
        },

        disconnect() {
            Auth.disconnect()

        }
    }

}

</script>

<style scoped lang="scss">

    .bsfn {
        &__container {
            width: 100%;
            padding: 24px 24px 32px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: $midnight;
            @media screen and (min-width: $above-tablet-length) {
                padding: 80px 24px;
            }
        }

        &__title {
            font-size: 17px;
            font-weight: bold;
            line-height: 1.29;
            color: $midnight;
            text-align: center;
        }

        &__btn-red {
            margin-top: 24px;
            width: auto;
            padding: 0 24px;
        }

        &__btn-grey {
            margin-top: 16px;
            width: auto;
            padding: 0 24px;
        }
    }

</style>
